import Vue from "vue";
import jquery from "jquery";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import VueContentLoading from "vue-content-loading";
import VueTimepicker from "vue2-timepicker";
import "vue2-timepicker/dist/VueTimepicker.css";
import Multiselect from "vue-multiselect";
import SimpleSelect from "./components/SimpleSelect";
import VueTippy, { TippyComponent } from "vue-tippy";
import VScrollLock from "v-scroll-lock";
import VueTrumbowyg from "vue-trumbowyg";
import "trumbowyg/dist/ui/trumbowyg.css";
import "trumbowyg/dist/plugins/upload/trumbowyg.upload";
import "trumbowyg/dist/plugins/colors/trumbowyg.colors";
import "bootstrap";
import VueToastify from "vue-toastify";

// Load jquery
window.$ = jquery;
window.jQuery = jquery;

Vue.use(VueTippy);
Vue.use(VueTrumbowyg);
Vue.use(VScrollLock);
Vue.use(VueToastify, {
  theme: "light",
  position: "top-right",
  successDuration: 1000,
  hideProgressbar: true
});

Vue.component("timePicker", VueTimepicker);
Vue.component("simple-select", SimpleSelect);
Vue.component("multiselect", Multiselect);
Vue.component("vue-content-loading", VueContentLoading);
Vue.component("tippy", TippyComponent);

import "./plugins/axios";

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
